import axios from "axios";

const API_BASE =
	process.env.REACT_APP_API_URL || "https://api.platform.ng-coaching.com";

const axiosInstance = axios.create({
	baseURL: API_BASE,
	withCredentials: true, // If you're using sessions/cookies
});

export default axiosInstance;
